import React from 'react';
import "../styles/NoutFound.css"

const NotFound = () => {
  return (
    <div className={"not-found"}>
      <div className="not-found_content">
        <h1>404</h1>
        <p>сторінка не була знайдена</p>
      </div>
    </div>
  );
};

export default NotFound;